import { render, staticRenderFns } from "./UpgradeContract.vue?vue&type=template&id=fa1075bc&"
import script from "./UpgradeContract.vue?vue&type=script&lang=js&"
export * from "./UpgradeContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports